<div class="signature-status-container">
  <div class="status-card">
    <!-- Header -->
    <div class="status-card__header">
      <div class="title-section">
        <mat-icon class="title-icon">draw</mat-icon>
        <h1>{{'GB_Registration_SignatoryStatusTitle' | translate}}</h1>
      </div>
    </div>

    <div class="status-card__content">
      <!-- Error/Status Messages -->
      <div *ngIf="!errorStatus" class="status-alert alert-info">
        <mat-icon>info</mat-icon>
        <span>{{'GB_Registration_SignatoryStatusMessage' | translate}}</span>
      </div>

      <div *ngIf="errorStatus" class="status-alert alert-error">
        <mat-icon>error</mat-icon>
        <span>{{errorStatus}}</span>
      </div>

      <!-- Signature Details -->
      <div class="details-section" *ngIf="signatureObject">
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">
              <mat-icon>business</mat-icon>
              <span>{{'General_Company' | translate}}</span>
            </div>
            <div class="detail-value">{{signatureObject.name}}</div>
          </div>

          <div class="detail-item" *ngIf="signatureObject.description">
            <div class="detail-label">
              <mat-icon>description</mat-icon>
              <span>{{'General_Description' | translate}}</span>
            </div>
            <div class="detail-value">{{signatureObject.description}}</div>
          </div>

          <div class="detail-item" *ngIf="signatureObject.procedureId">
            <div class="detail-label">
              <mat-icon>work_outline</mat-icon>
              <span>Procedure</span>
            </div>
            <div class="detail-value code-value">{{signatureObject.procedureId}}</div>
          </div>

          <div class="detail-item" *ngIf="signatureObject.createdAt">
            <div class="detail-label">
              <mat-icon>event_available</mat-icon>
              <span>{{'General_CreatedAt' | translate}}</span>
            </div>
            <div class="detail-value">{{signatureObject.createdAt | date:'medium'}}</div>
          </div>

          <div class="detail-item" *ngIf="signatureObject.expiresAt">
            <div class="detail-label">
              <mat-icon>event_busy</mat-icon>
              <span>{{'General_ExpiresAt' | translate}}</span>
            </div>
            <div class="detail-value">
              <span [class.expiring-soon]="isExpiringSoon(signatureObject.expiresAt)">
                {{signatureObject.expiresAt | date:'medium'}}
              </span>
            </div>
          </div>

          <div class="detail-item" *ngIf="signatureObject?.file?.path">
            <div class="detail-label">
              <mat-icon>folder</mat-icon>
              <span>{{'General_FileName' | translate}}</span>
            </div>
            <div class="detail-value">
              <a [href]="cardboardURL + signatureObject.file.path" class="file-link" target="_blank"
                [matTooltip]="'General_Download' | translate">
                <mat-icon class="file-icon">download</mat-icon>
                {{signatureObject.file.name}}
              </a>
            </div>
          </div>
        </div>

        <!-- Progress Indicator -->
        <div class="progress-section">
          <div class="progress-header">
            <mat-icon>group</mat-icon>
            <span>{{'General_Members' | translate}}</span>
            <mat-chip class="progress-chip">
              {{getSignedCount()}}/{{signatureObject.members?.length || 0}}
            </mat-chip>
          </div>

          <mat-progress-bar mode="determinate" [value]="getProgressPercentage()"
            [class.complete]="getProgressPercentage() === 100">
          </mat-progress-bar>
        </div>

        <!-- Members List -->
        <div class="members-section">
          <div class="member-card" *ngFor="let member of signatureObject.members; let i = index"
            [class.signed]="member.signed" [class.pending]="!member.signed">
            <div class="member-avatar">
              <mat-icon class="avatar-icon" [class.signed]="member.signed">
                {{member.signed ? 'check_circle' : 'pending'}}
              </mat-icon>
            </div>

            <div class="member-info">
              <div class="member-name">{{member.firstName}} {{member.lastName}}</div>

              <div class="member-status">
                <mat-icon *ngIf="member.signed" class="status-icon signed">check_circle</mat-icon>
                <mat-icon *ngIf="!member.signed" class="status-icon pending">schedule</mat-icon>

                <span *ngIf="member.signed" class="status-text signed">
                  {{'General_Signed' | translate}} {{'General_At' | translate}} {{member.dateSigned | date:'medium'}}
                </span>
                <span *ngIf="!member.signed" class="status-text pending">
                  {{'General_Pending' | translate}}
                </span>
              </div>

              <a *ngIf="member.link" [href]="member.link" class="yousign-link" target="_blank"
                rel="noopener noreferrer">
                <mat-icon>open_in_new</mat-icon>
                <span>{{'GB_Registration_SignatoryStatusMemberLink' | translate}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="!signatureObject && !errorStatus" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{'General_Loading' | translate}}</p>
      </div>
    </div>
  </div>
</div>
